import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { UrgencyBanner } from './components/UrgencyBanner';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen font-sans text-slate-800 bg-slate-50 selection:bg-[#1a365d] selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProofBar data-id="element-3" />
      <TomosSection data-id="element-4" />
      <BonusSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <UrgencyBanner data-id="element-7" />
      <PricingSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <Footer data-id="element-11" />
      <PurchasePopup data-id="element-12" />
    </div>;
}